import WidgetBase from "../common/widgetBase";
import Message from "../common/message";
import { Converter } from "../../workspace/converter";
import EnvelopeControls from "../common/envelopeControls";

export default class MessageNode extends WidgetBase {
  getBoundAlias() {
    return Converter.getComponentPortValueData(this.props.data.component, "message");
  }

  // The bound message envelope, or null when no alias is bound, the value is
  // not loaded yet, or it is not a message-typed object.
  getEnvelopeValue() {
    const alias = this.getBoundAlias();
    if ( !alias || !this.context ) return null;
    const value = this.context.getSessionData(alias);
    return value && value.type === "message" ? value : null;
  }

  renderHeaderAlias() {
    const alias = this.getBoundAlias();
    if ( !alias ) return null;
    return <span className="playground-widget-alias">{alias}</span>;
  }

  renderHeaderActions() {
    return (
      <EnvelopeControls
        alias={this.getBoundAlias()}
        value={this.getEnvelopeValue()}
        shellInterface={this.props.data.shellInterface}
        sessionManager={this.context}
      />
    );
  }

  renderBody() {
    const [messageValue, notice] = this.loadObjectValue(
      this.props.data.component, "message", "message");
    if ( notice ) return this.renderNotice(notice);

    const contentView = Converter.getComponentPortValueData(this.props.data.component, "content_view");

    return (
      <Message
        value={messageValue}
        contentView={contentView}
      />
    );
  }
}
